import React, { useContext, useState } from 'react';
import { Pressable, Text } from 'react-native';

import AuthContext from 'app/src/contexts/AuthContext';
import { SubNavContainer, LinkContainer, LinkSpace } from 'app/src/elements';
import Modal from 'app/src/elements/Modal';
import { Link } from 'app/src/utils/routing';

import NewExpense from './new';

const SubNav = ({ refetch }) => {
  const { hasPolicy } = useContext(AuthContext);
  const [showAddModal, setShowAddModal] = useState(false);

  const pathname = window.location.pathname;

  return (
    <SubNavContainer>
      <LinkContainer>
        {hasPolicy({ type: 'Expense', action: 'create' }) && (
          <>
            <Pressable onPress={() => setShowAddModal('Expense')} >
              <Text>+ Add Expense</Text>
            </Pressable>
            <LinkSpace />

            <Pressable onPress={() => setShowAddModal('Bill')} >
              <Text>+ Add Bill</Text>
            </Pressable>
            <LinkSpace />

            <Pressable onPress={() => setShowAddModal('Credit Card Charge')} >
              <Text>+ Add Credit Card Charge</Text>
            </Pressable>
            <LinkSpace />

            {'/accounting/expenses/vendor-issues' === pathname ? (
              <Link to="/accounting/expenses">
                <Text>Expenses</Text>
              </Link>
            ) : (
              <Link to="/accounting/expenses/vendor-issues">
                <Text>Expenses Missing Vendor Data</Text>
              </Link>
            )}
            <LinkSpace />
          </>
        )}
      </LinkContainer>

      {showAddModal &&
        <Modal
          showModal
          setShowModal={setShowAddModal}
          modalType={`Add ${showAddModal}`}
        >
          <NewExpense
            setShowModal={setShowAddModal}
            type={showAddModal}
            refetch={refetch}
          />
        </Modal>
      }
    </SubNavContainer>
  );
};

export default SubNav;
